import React from "react";
import { motion } from "framer-motion";

// Scroll-reveal wrapper
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Kicker / eyebrow label
export const Kicker = ({ children, className = "" }) => (
  <span
    className={`inline-block text-xs md:text-sm uppercase tracking-[0.28em] text-[#6A1E27] font-medium ${className}`}
  >
    {children}
  </span>
);

export default Reveal;
